import { createContext, useContext, useEffect, useState } from "react";
import { api, setTz } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);

  const loadSettings = async () => {
    try {
      const r = await api.get("/settings");
      setTz(r.data.tz_offset);
      setSettings(r.data);
    } catch (e) {
      setSettings(null);
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("gomenu_token")) {
      setUser(false);
      return;
    }
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      loadSettings();
    }).catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gomenu_token", r.data.token);
    setUser(r.data.user);
    loadSettings();
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("gomenu_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, settings, setSettings, loadSettings }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
